import { httpPost } from '@/utils/service'

export async function create ({ payCountry, poList }) {
  try {
    const response = await httpPost('CREATE_PAYMENT_TXN', {
      data: {
        payCountry,
        poList
      }
    })
    return response.data
  } catch (error) {
    if (error.response) {
      throw error.response
    }
    throw error
  }
}

export async function retry (transactionUid) {
  try {
    const response = await httpPost('RETRY_PAYMENT_TXN', {
      data: { transactionUid }
    })
    return response.data
  } catch (error) {
    if (error.response) {
      throw error.response
    }
    throw error
  }
}

export async function updateTransactionStatus (transactionUid, transactionStatus) {
  try {
    const response = await httpPost('UPDATE_TXN_STATUS',
      {
        params: { transactionUid },
        data: { transactionStatus }
      }
    )
    return response.data
  } catch (error) {
    if (error.response) {
      throw error.response
    }
    throw error
  }
}
